import React from "react";
import "../../../layouts/main/";
import { Button, Offcanvas } from "react-bootstrap";
import "./search.css";
import "../../../layouts/main/Navbar.css";
import { useClickOutside } from "../../../utils/helpers";
import CurrencyFormat from "react-currency-format";
import { currencySymbol } from "../../../utils/helpers";
export const SearchShow = ({
  showSearchCanvas,
  hideSearchCanvas,
  show,
  setSearchKeyword,
  searchKeyword,
  handleSearch,
  search,
  searchedItems,
  isGlobalSearchLoading,
  handelSearchedItemSelection,
}) => {
  let domNode = useClickOutside(() => {
    hideSearchCanvas();
  });
  return (
    <Offcanvas
      className={"SearchBoxCanvas"}
      show={show}
      onHide={hideSearchCanvas}
      placement="end"
    >
      <Offcanvas.Header
        closeButton
        className="offcanvas-header border-bottom"
        id="header"
      >
        <Offcanvas.Title>
          <h5
            className="offcanvas-title text-primary"
            id="MobileSearchOffcanvasLabel"
          >
            <i className="fas fa-dolly"></i> Search Items
          </h5>
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body ref={domNode} className="offcanvas-body header_top">
        <div className="search_block">
          <div className="input-group w-100">
            <input
              type="text"
              onChange={handleSearch}
              value={searchKeyword}
              className="form-control"
              placeholder="Enter a keyword"
            />
            <a
              href="#"
              className="upload_search"
              data-bs-toggle="modal"
              data-bs-target="#SearchByImage"
            >
              <i data-feather="camera"></i>
            </a>
            <Button className="btn btn-primary" onClick={search}>
              <i className="fa-solid fa-magnifying-glass"></i> Search
            </Button>
          </div>
        </div>
        <div className="global_search_div_responsive">
          <ul>
            {searchKeyword &&
              (isGlobalSearchLoading ? (
                <li>
                  <div className="item_description">Searching</div>
                </li>
              ) : searchedItems?.length > 0 ? (
                searchedItems.map((data, index) => (
                  <li key={index}>
                    <a
                      className="search_item"
                      onClick={() => handelSearchedItemSelection(data?.title)}
                    >
                      <div className="item_image">
                        {data.variant_image ? (
                          <img src={data?.variant_image.url} />
                        ) : (
                          <img
                            src={`${process.env.PUBLIC_URL}/images/placeholder-images.png`}
                          />
                        )}
                      </div>
                      <div className="item_description">
                        <span>{data?.title}</span>
                        {/* <p className="item_sub_description">
                        {data?.attributes.replace(/['"]+/g, "")}
                      </p> */}
                      </div>
                      <div className="item_price">
                        {currencySymbol()}{" "}
                        {data.price && (
                          <CurrencyFormat
                            value={data.price}
                            displayType={"text"}
                            thousandSeparator={true}
                            fixedDecimalScale={true}
                            decimalScale={2}
                          />
                        )}
                      </div>
                    </a>
                  </li>
                ))
              ) : (
                <li>
                  <div className="item_description">No record found</div>
                </li>
              ))}
          </ul>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};
